/*  MUI  */
import { Box, Tab } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

/*  Components  */
import { ClientAppsDashboard } from './internal/ClientAppsDashboard';
import Overview from './internal/Overview';

const AppsTabs = () => {
    const { t } = useTranslation();
    const { clientId, partnerId, tab } = useParams();
    const activeTab = tab ?? 'insights';

    const baseAdminRoute = Route.buildBaseAdminRoute({
        clientId,
        partnerId
    });

    return (
        <MUITabsWrapper value={activeTab}>
            <Tab
                component={Link}
                to={`${baseAdminRoute}/applications/insights`}
                data-testid="appsTabsInsights"
                value="insights"
                label={t('ApplicationDashboard.applicationInsights')}
                aria-label={t('ApplicationDashboard.applicationInsights')}
            />
            <Tab
                component={Link}
                to={`${baseAdminRoute}/applications/inventory`}
                data-testid="appsTabsInventory"
                value="inventory"
                label={t('ApplicationDashboard.applicationInventory')}
                aria-label={t('ApplicationDashboard.applicationInventory')}
            />
        </MUITabsWrapper>
    );
};

export const AdminApplications = () => {
    const { t } = useTranslation();
    const { tab } = useParams();
    const activeTab = tab ?? 'insights';

    return (
        <Box>
            <PageTitle title={t('Common.applications')} />
            <AppsTabs />
            {activeTab === 'insights' && <Overview />}
            {activeTab === 'inventory' && <ClientAppsDashboard />}
        </Box>
    );
};
